export const ApiUrl = 'https://etc-api.supernovaq.se/api/';
